import { useCallback } from "react";
import { Tab, Tabs } from "react-bootstrap";
import ListTickets from "./_ListTickets";
import FormGuestlist from "./_FormGuestlist";
import ListTables from "./_ListTables";

const EventTabs = ({
    state,
    setState,
    handleChangeInputsGuestList,
    handlerSubmitFormEvent,
    setIsLoading,
    getInfoFormEvent,
    activeTab,
    setActiveTab,
}) => {

    const submitModuleUpdate = (module) => {
        const newState = {
            ...state,
            form: {
                ...state.form,
                [module]: {
                    ...state.form[module],
                    enable: !state.form[module].enable,
                },
            },
        };
        setState(newState);
        handlerSubmitFormEvent(newState);
    }

    return (
        <div className="mt-4">
            <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="premium-tabs border-0 mb-3"
            >
                <Tab eventKey="guestlist" title={
                    <span>
                        <i className="fa-solid fa-qrcode me-2"></i> Guest list
                    </span>
                }>
                    <div className="campaign-card border-0 p-4 min-h-400">
                        <div style={{ display: state.form.guestlist.enable ? "block" : "none" }} >
                            <div className="mb-4">
                                <h4 className="title mb-1">Configuração de Guest List</h4>
                                <p className="text-muted small">Gere as entradas e limites da tua lista de convidados.</p>
                            </div>

                            <FormGuestlist
                                visible
                                handleChangeForm={(e) => handleChangeInputsGuestList(e)}
                                form={state.form.guestlist}
                            />

                            <div className="mt-5 pt-4 border-top border-white border-opacity-10 text-end">
                                <button
                                    className="btn-action btn-campaign-secondary px-4 w-auto d-inline-flex"
                                    onClick={() => submitModuleUpdate("guestlist")}
                                >
                                    <i className="fa-solid fa-lock me-2"></i>Desativar Módulo
                                </button>
                            </div>
                        </div>

                        <div className="py-5" style={{ display: state.form.guestlist.enable ? "none" : "block" }}>
                            <div className="instruction-box text-center p-5 rounded-4 border border-white border-opacity-10  bg-opacity-5">
                                <div className="icon-box-premium mx-auto mb-4" style={{ width: '80px', height: '80px', fontSize: '2.5rem' }}>
                                    <i className="fa-solid fa-qrcode text-muted opacity-50"></i>
                                </div>
                                <h3 className="text-white fw-bold mb-2">Módulo Guest List Desativado</h3>
                                <p className="text-muted mx-auto mb-4" style={{ maxWidth: '400px' }}>
                                    Ativa este módulo para permitires que os teus clientes e promotores adicionem nomes à lista de convidados do evento.
                                </p>
                                <button className="btn-action glass-glow btn-campaign-primary px-5 py-3 w-auto rounded-pill mx-auto d-flex" onClick={() => submitModuleUpdate("guestlist")}>
                                    <i className="fa-solid fa-power-off me-2"></i> Ativar Agora
                                </button>
                            </div>
                        </div>
                    </div>
                </Tab>

                <Tab eventKey="tables" title={
                    <span>
                        <i className="fa-solid fa-couch me-2"></i> Mesas
                    </span>
                }>
                    <div className="campaign-card border-0 p-4 min-h-400">
                        <div style={{ display: state.form.tables.enable ? "block" : "none" }}>
                            <div className="mb-4">
                                <h4 className="title mb-1">Gestão de Mesas VIP</h4>
                                <p className="text-muted small">Configura a disponibilidade e preços das mesas para este evento.</p>
                            </div>

                            <ListTables listTables={state.form.tables.list} />

                            <div className="mt-5 pt-4 border-top border-white border-opacity-10 text-end">
                                <button
                                    className="btn-action btn-campaign-secondary px-4 w-auto d-inline-flex"
                                    onClick={() => submitModuleUpdate("tables")}
                                >
                                    <i className="fa-solid fa-lock me-2"></i>Desativar Módulo
                                </button>
                            </div>
                        </div>

                        <div className="py-5" style={{ display: state.form.tables.enable ? "none" : "block" }}>
                            <div className="instruction-box text-center p-5 rounded-4 border border-white border-opacity-10  bg-opacity-5">
                                <div className="icon-box-premium mx-auto mb-4" style={{ width: '80px', height: '80px', fontSize: '2.5rem' }}>
                                    <i className="fa-solid fa-couch text-muted opacity-50"></i>
                                </div>
                                <h3 className="text-white fw-bold mb-2">Módulo de Mesas Desativado</h3>
                                <p className="text-muted mx-auto mb-4" style={{ maxWidth: '400px' }}>
                                    Ativa a reserva de mesas para permitires que os teus clientes reservem áreas VIP diretamente pela aplicação.
                                </p>
                                <button className="btn-action glass-glow btn-campaign-primary px-5 py-3 w-auto rounded-pill mx-auto d-flex" onClick={() => submitModuleUpdate("tables")}>
                                    <i className="fa-solid fa-power-off me-2"></i> Ativar Agora
                                </button>
                            </div>
                        </div>
                    </div>
                </Tab>

                <Tab eventKey="tickets" title={
                    <span>
                        <i className="fa-solid fa-ticket me-2"></i> Bilhetes
                    </span>
                }>
                    <div className="campaign-card border-0 p-4 min-h-400">
                        <div style={{ display: state.form.tickets.enable ? "block" : "none" }}>
                            <div className="mb-4">
                                <h4 className="title mb-1">Bilheteira Digital</h4>
                                <p className="text-muted small">Cria diferentes tipos de bilhetes e gere o inventário de vendas.</p>
                            </div>

                            <ListTickets listTickets={state.form.tickets.list} setIsLoading={setIsLoading} getInfoFormEvent={getInfoFormEvent} />

                            <div className="mt-5 pt-4 border-top border-white border-opacity-10 text-end">
                                <button
                                    className="btn-action btn-campaign-secondary px-4 w-auto d-inline-flex"
                                    onClick={() => submitModuleUpdate("tickets")}
                                >
                                    <i className="fa-solid fa-lock me-2"></i>Desativar Módulo
                                </button>
                            </div>
                        </div>

                        <div className="py-5" style={{ display: state.form.tickets.enable ? "none" : "block" }}>
                            <div className="instruction-box text-center p-5 rounded-4 border border-white border-opacity-10  bg-opacity-5">
                                <div className="icon-box-premium mx-auto mb-4" style={{ width: '80px', height: '80px', fontSize: '2.5rem' }}>
                                    <i className="fa-solid fa-ticket text-muted opacity-50"></i>
                                </div>
                                <h3 className="text-white fw-bold mb-2">Módulo de Bilhética Desativado</h3>
                                <p className="text-muted mx-auto mb-4" style={{ maxWidth: '400px' }}>
                                    Vende bilhetes online e controla os acessos ao teu evento de forma segura e profissional.
                                </p>
                                <button className="btn-action glass-glow btn-campaign-primary px-5 py-3 w-auto rounded-pill mx-auto d-flex" onClick={() => submitModuleUpdate("tickets")}>
                                    <i className="fa-solid fa-power-off me-2"></i> Ativar Agora
                                </button>
                            </div>
                        </div>
                    </div>
                </Tab>
            </Tabs>
        </div>
    )
}

export default EventTabs
